import { createMock } from '../../utils/builderHelper.es.js';

/** @module Mocks */ /** typedoc */
const aSplitVersion = createMock({
    versionKey: 0,
    sharePercentage: 50,
});

export { aSplitVersion };
